import {OffersManagementListingItem, Pagination} from 'common/types';

export enum ObjectScreenMode {
  City = 'city',
  Agency = 'agency',
  Afnu = 'afnu',
  Sfnu = 'sfnu',
  Partner = 'partner',
  Owner = 'owner',
  PayCommission = 'payCommission',
}

export interface ObjectChipsCounters {
  cityName: string;
  city: number;
  agency: number;
  afnu: number;
  sfnu: number;
  partner: number;
  owner: number;
  payCommission: number;
}

export interface ObjectScreenItem extends OffersManagementListingItem {
  isLunOffer: boolean;
  username: string;
  domain: string;
  avatar: string;
  verificated: boolean;
  isPro: boolean;
  permissions: number;
  unpublish_date: string;
  phone: number;
  priceM2: string;
  houseNumber?: string;
  newHouse?: string;
  cottage?: string;
}

export interface ObjectsDataListing {
  pagination: Pagination;
  sort?: string;
  items: ObjectScreenItem[];
  clicksEnabled: {
    objects: boolean,
    phones: boolean,
  };
}

export enum ObjectLogType {
  ObjectClick = 1,
  PhoneClick = 2,
}

export interface ObjectsLog {
  rentaItemId: number;
  rentaOwnerId: number;
  userId: number;
  type: ObjectLogType;
}

export interface ItemRowProps {
  item: ObjectScreenItem;
  mode?: string;
  showDistrictColumn: boolean;
}
